import React, {ReactElement} from "react";
import {styled} from "@reside/ui";

type Props = Readonly<{
  dateSelector: ReactElement;
}>;

const Wrapper = styled.div`
  margin-bottom: 15px;
  padding: 20px;
  border: 1px solid ${({theme}) => theme.color.gray10};
  background: ${({theme}) => theme.color.white};
`;

export const ReportingActionRow = ({dateSelector}: Props) => (
  <Wrapper>{dateSelector}</Wrapper>
);
